/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { addMyList } from '../../redux/myList';
import { getMovie } from '../../redux/playMovie';
import loader from '../../assets/loader.gif';
import './Movie.css';

const baseUrl = 'https://image.tmdb.org/t/p/original/';

const Movie = (props) => {

  const dispatch = useDispatch();

  const { title, fetchUrl } = props;

  const [movies, setMovies] = useState([]);

  const location = useLocation();

  const myStyle = {
    width: '100%',
    flexWrap: 'no-wrap',
  };

  const otherStyle = {
    width: 'auto',
    flexWrap: 'wrap',
  };
  
  const fetchResults = fetchUrl?.results || fetchUrl;

  useEffect(() => {
    setMovies(fetchResults);
  }, [fetchResults]);

  const handleClick = (movie) => {
    const play = true;
    const playMovieProps = { movie, play };
    dispatch(getMovie(playMovieProps));
    // dispatch(addMyList(movie, { type: 'ADD_MYLIST' }));
  };


  return (
    <>
      <h2 className="movies-category">{title}</h2>
      {movies.length !== 0 ? (
      <div className="movie-sections" style={location.pathname === '/' || location.pathname === '/movies' || location.pathname === '/tv-shows' || location.pathname === '/new-and-popular' ? { ...myStyle } : { ...otherStyle }}>
        {movies.map((movie) => (
          <button type="button" key={movie.id} onClick={() => handleClick(movie)} className="single-movie">
            <img className="movie-image" src={`${baseUrl}${movie?.poster_path}`} alt={movie?.title} />
            {/* <div className="single-movie-info">
              <h3>{movie?.title}</h3>
              <p>{movie?.overview}</p>
            </div> */}
          </button>
        ))}
      </div> ) : (
        <div className="pop-movie-loader-section">
        <img src={loader} className="pop-movie-loader" alt="FlixFrenzy" />
      </div>
      )}

    </>

  );
};

// Movie.propTypes = {
//   fetchUrl: PropTypes.objectOf(PropTypes.object()).isRequired,
//   title: PropTypes.string.isRequired,
// };

/* eslint-enable react/prop-types */

// const { title, fetchUrl } = Movie.props;

// const myPropTypes = {
//   fetchUrl: PropTypes.objectOf(PropTypes.object()).isRequired,
//   title: PropTypes.string.isRequired,
// };

PropTypes.checkPropTypes(Movie.propTypes, Movie.props, Movie.fetchUrl, Movie.title, Movie);

export default Movie;
